import React, { useEffect, useState } from "react";
import { ResponsiveBar } from "@nivo/bar";
import { useSelector } from "react-redux";

const keys = ["total", "completed"];

const ValueOutside = ({ bars, yScale }) => {
  return bars.map((bar) => {
    const { key, width, x, data } = bar;
    const { value } = data;
    const labelMargin = 20;
    return (
      <g
        key={key}
        transform={`translate(${x}, ${yScale(value) - labelMargin})`}
        fill="#757575"
      >
        <text
          // textAnchor="top"
          fontSize="11px"
          x={width / 4}
          y={labelMargin / 2}
          textAnchor="middle"
          alignmentBaseline="central"
        >
          {value}
        </text>
      </g>
    );
  });
};

const CustomLeftLabel = (data) => {
  const { y, value } = data;
  return (
    <g>
      <text x={-20} y={y + 4} fontSize="12px" fill="#757575">
        {value}
      </text>
    </g>
  );
};

const HoursByDocumentGraph = () => {
  const [data, setData] = useState([]);
  const { total, completed } = useSelector(
    (state) => state.documentControlReducer
  );
  const colors = {
    completed: "#e21c21",
    total: "#172657",
  };
  const getColor = (bar) => colors[bar.id];
  useEffect(() => {
    setData([{ total: total, completed: completed }]);
  }, []);
  const CustomBarComponent = ({ bar: { x, y, width, height, color } }) => {
    return (
      <rect
        x={x + width / 4 - width / 4}
        y={y}
        width={width / 2}
        height={height}
        fill={color}
      />
    );
  };
  return (
    <div style={{ height: "400px" }}>
      <ResponsiveBar
        data={data}
        keys={keys}
        barComponent={CustomBarComponent}
        indexBy="label"
        margin={{
          top: 50,
          right: 0,
          bottom: 120,
          left: 50,
        }}
        groupMode="grouped"
        colors={getColor}
        padding={0.4}
        borderColor="inherit:darker(1.6)"
        enableLabel={false}
        enableGridX={false}
        enableGridY={true}
        theme={{
          axis: {
            ticks: {
              line: {
                stroke: null,
              },
            },
            domain: {
              line: {
                stroke: "", // verticle line
                strokeWidth: 2,
              },
            },
            legend: {
              text: {
                fontWeight: "bold",
                letterSpacing: "2px",
              },
            },
          },
          grid: {
            line: {
              stroke: `rgb(231 232 236 / 80%)`,
              strokeWidth: 2,
              strokeDasharray: "2, 4",
            },
          },
        }}
        layers={["grid", "axes", "bars", "markers", ValueOutside]}
        legends={[
          {
            dataFrom: "keys",
            // data: keys.map((key, index) => ({
            //   color: colors[index],
            //   key,
            //   // label: key === "ordered" ? 1 : 2,
            //   label: key,
            // })),
            anchor: "bottom",
            direction: "row",
            translateY: 63,
            itemWidth: 80,
            itemHeight: 20,
            itemDirection: "left-to-right",
            symbolSize: 20,
          },
        ]}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "Total vs Completed",
          legendPosition: "middle",
          legendOffset: -40,
          renderTick: CustomLeftLabel,
          tickValues: 3,
        }}
      />
    </div>
  );
};

export default HoursByDocumentGraph;
